import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateFrameworkAgreementSettingValue = async (frameworkAgreementId, key, value) => {
  // Same string-cast fix as the global settings mutation - a numeric setting's
  // Yup schema casts the form value to a JS number, but the backend `value`
  // column is always a string, so it's stringified back here.
  return axios.patch(
    `/api/framework_agreements/${frameworkAgreementId}/settings/${key}`,
    JSON.stringify({ value: String(value) })
  );
};

export const useUpdateFrameworkAgreementSettingValue = (frameworkAgreementId, key) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (value) => updateFrameworkAgreementSettingValue(frameworkAgreementId, key, value),
    onSuccess: () => {
      enqueueSnackbar('Setting was successfully updated', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
